// SME Capture Flow — Phase 2 timeline edit helpers (pure).
//
// The expert reviews the ordered timeline and adjusts it: reorder, rename
// (split/merge come later). These are pure array ops so the editing logic is
// unit-tested without rendering (tests/captureTimeline.test.ts).

export interface TimelineEntry {
  id: string;
  text: string;
  sourceTrackIds?: string[];
  sourceEventIds?: string[];
  originalPhrases?: string[];
}

// Move the entry at `index` one slot up or down. Out-of-bounds is a no-op
// (returns the same array reference), so callers can wire ↑/↓ without guards.
export function moveEntry<T>(list: T[], index: number, dir: 'up' | 'down'): T[] {
  const target = dir === 'up' ? index - 1 : index + 1;
  if (index < 0 || index >= list.length || target < 0 || target >= list.length) return list;
  const copy = list.slice();
  [copy[index], copy[target]] = [copy[target], copy[index]];
  return copy;
}

// Replace the text of the entry with the given id (immutably).
export function renameEntry<T extends { id: string; text: string }>(list: T[], id: string, text: string): T[] {
  return list.map((e) => (e.id === id ? { ...e, text } : e));
}
